import { IBaseModel } from '../../../shared/interfaces/shared/IBase';
import { IPagination } from '../../../shared/interfaces/shared/IPagination';
import {
  IFinishContribution,
  ITeamContributions,
} from '../../../shared/interfaces/team-contributions/ITeamContributions';
import { requests } from '../../../utils/api/api.service';
import { TEAM_CONTRIBUTIONS_URL } from '../../../utils/api/endpoints';

export const AdminTeamContributionsService = {
  get: (pagination: IPagination): Promise<IBaseModel<ITeamContributions[]>> =>
    requests.get(TEAM_CONTRIBUTIONS_URL, pagination),
  getSingle: (id: number): Promise<ITeamContributions> =>
    requests.get(`${TEAM_CONTRIBUTIONS_URL}/${id}`),
  create: (params: ITeamContributions): Promise<ITeamContributions> =>
    requests.post(TEAM_CONTRIBUTIONS_URL, params),
  update: (
    params: ITeamContributions,
    id: number,
  ): Promise<ITeamContributions> =>
    requests.put(`${TEAM_CONTRIBUTIONS_URL}/${id}`, params),
  delete: (id: number): Promise<ITeamContributions> =>
    requests.delete(`${TEAM_CONTRIBUTIONS_URL}/${id}`),
  finish: (params: IFinishContribution): Promise<ITeamContributions> =>
    requests.patch(`${TEAM_CONTRIBUTIONS_URL}/user-finished`, params),
};
